import BaseService from '../base';

class Vehicle extends BaseService { }

export default new Vehicle('section-vehicles', 'SectionVehicle');
